<div class="banner-container">
    <section class="lps-cta-banner lps-cta-banner--red">
        <div class="lps-cta-banner__info">
            <img class="lps-cta-banner__thumb" src="../../assets/imgs/thumbnail-agent-page.png" alt="Thumbnail página do corretor">
            <div class="lps-cta-banner__text">
                <h2 class="lps-cta-banner__title lps-hide-onmobile">Já conferiu sua página de corretor? Ela é seu cartão de visitas digital.</h2>
                <h2 class="lps-cta-banner__title lps-visible-onmobile">Já conferiu sua página de corretor?</h2>
                <p class="lps-cta-banner__description">Atualize seus dados de telefone, capriche na sua descrição e compartilhe com seus clientes.</p>
            </div>
        </div>
        <span class="lps-cta-banner__btn lps-btn lps-btn-primary lps-btn--rounded" (click)="clickRedirectAgentPage()">Acessar minha página</span>
    </section>
</div>